module.exports = __webpack_public_path__ + "img/menu_icon07.51c14cb2.png";